/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BDUpdateItem,
    BDUpdateItemFromJSON,
    BDUpdateItemFromJSONTyped,
    BDUpdateItemToJSON,
    BDUpdateType,
    BDUpdateTypeFromJSON,
    BDUpdateTypeFromJSONTyped,
    BDUpdateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface BDOperation
 */
export interface BDOperation {
    /**
     * 
     * @type {string}
     * @memberof BDOperation
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {object}
     * @memberof BDOperation
     */
    updatedDate?: object;
    /**
     * 
     * @type {BDUpdateType}
     * @memberof BDOperation
     */
    type?: BDUpdateType;
    /**
     * 
     * @type {Array<BDUpdateItem>}
     * @memberof BDOperation
     */
    readonly updates?: Array<BDUpdateItem> | null;
}

export function BDOperationFromJSON(json: any): BDOperation {
    return BDOperationFromJSONTyped(json, false);
}

export function BDOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BDOperation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : json['updatedDate'],
        'type': !exists(json, 'type') ? undefined : BDUpdateTypeFromJSON(json['type']),
        'updates': !exists(json, 'updates') ? undefined : (json['updates'] === null ? null : (json['updates'] as Array<any>).map(BDUpdateItemFromJSON)),
    };
}

export function BDOperationToJSON(value?: BDOperation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate,
        'type': BDUpdateTypeToJSON(value.type),
    };
}


